/** Plan -> feature list mapping. CUSTOM uses '*' (all features). Checked by usePlan() hook.
 *  Replaced by a dynamic, Super-Admin-managed source of truth in Phase 5 —
 *  this stays as the fail-open default if subscription-service is down. */
export const PLAN_FEATURES = {
  BASIC: ['manual_attendance', 'basic_reports', 'chat'],
  PRO: [
    'manual_attendance', 'gps_attendance', 'selfie_attendance',
    'qr_attendance', 'payroll', 'custom_salary', 'compliance',
    'expense', 'recruitment', 'advanced_analytics', 'custom_roles',
    'white_label_payslip', 'chat', 'documents',
  ],
  CUSTOM: ['*'],
};

/** Permission string constants — used as keys in usePerm() checks. */
export const PERMISSIONS = {
  EMPLOYEE_VIEW: 'employee:view',
  EMPLOYEE_CREATE: 'employee:create',
  EMPLOYEE_EDIT: 'employee:edit',
  EMPLOYEE_TERMINATE: 'employee:terminate',
  ATTENDANCE_VIEW_TEAM: 'attendance:view_team',
  ATTENDANCE_VIEW_ALL: 'attendance:view_all',
  ATTENDANCE_REGULARIZE: 'attendance:regularize',
  PAYROLL_VIEW_SALARY: 'payroll:view_salary_structure',
  PAYROLL_RUN: 'payroll:run_payroll',
  LEAVE_VIEW_TEAM: 'leave:view_team',
  LEAVE_VIEW_ALL: 'leave:view_all',
  LEAVE_APPROVE: 'leave:approve',
  EXPENSE_VIEW_TEAM: 'expense:view_team',
  EXPENSE_VIEW_ALL: 'expense:view_all',
  EXPENSE_APPROVE: 'expense:approve',
  RECRUITMENT_VIEW: 'recruitment:view_jobs',
  RECRUITMENT_MANAGE: 'recruitment:manage_jobs',
  COMPLIANCE_VIEW: 'compliance:view_filings',
  REPORTS_VIEW: 'reports:view_attendance_report',
  ROSTER_VIEW: 'roster:view',
  ROLES_MANAGE: 'roles:manage',
};
